export const chartOption1 = {
  name: "全国",
  pluginNames: [],
  isAutoPlayToolTip: false,
  autoPlayToolTipIntervalTime: 1000,
  center: [107.4, 33.42], //地图中心点经纬度
  deepMap: false,
  areaColor: "rgba(46, 12, 144, 1)", //地图区块颜色
  primaryBorderColor: "rgba(48, 122, 255, 1)", //地图边框颜色
  primaryBorderWidth: 1, //地图边界默认border宽度
  selectBorderColor: "rgba(48, 122, 255, 1)", //地图边框颜色
  selectColor: "rgba(61, 225, 224, 1)", //地图选中和hover的颜色
  selectBorderWidth: 1, //地图边界选中border宽度
  showLabel: true,
  showScatter: false,
  showHot: false,
  showLines: false,
  showBar: false,
  zoom: 0.1,
  tooltip: {
    show: false,
    trigger: "item",
    triggerOn: "mousemove"
  },
  label: {
    labelFontColor: "rgba(255, 255, 255, 0.7)",
    labelFontFamily: "sans-serif",
    labelFontSize: 12,
    labelFontWeight: 700
  },
  select: {
    selectFontColor: "rgba(255, 255, 255, 0.7)",
    selectFontFamily: "sans-serif",
    selectFontSize: 16,
    selectFontWeight: 700
  },
  visualMap: {
    type: "continuous", //piecewise
    mapeType: "china",
    show: false,
    min: 0,
    max: 1000,
    calculable: true,
    orient: "vertical",
    left: 10,
    top: 50,
    handleIcon:
      "M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z",
    showHandleIcon: true,
    textStyle: {
      color: "#fff"
    },
    mapStartColor: "rgba(161, 179, 224, 1)",
    mapEndColor: "rgba(0, 71, 255, 1)",
    inRange: {
      color: ["rgba(161, 179, 224, 1)", "rgba(0, 71, 255, 1)"]
    },
    dataFormatter: [],
    hotName: ''
  },
  lines: {
    data: null, //飞线数据
    map: null,
    centerData: null, //飞线中心点数据
    lineStyle: {
      color: "rgba(183, 0, 255, 1)",
      width: 2,
      type: "dotted",
      curveness: 0.3,
      opacity: 0.5
    },
    effect: {
      show: true, //显示特效
      symbolSize: 10, //箭头大小
      period: 4, //箭头速度
      symbol: "arrow", //箭头图标
      trailColor: "#FF58C7",
      trailLength: 0.1 //尾迹的长度
    },
    label: {
      show: false,
      position: "start",
      fontColor: "rgba(255, 255, 255, 0.7)",
      fontFamily: "sans-serif",
      fontSize: 8,
      fontWeight: 400
    }
  },
  bar: {
    data: null,
    map: null,
    itemStyle: {
      color: "rgba(78, 219, 255, 1)",
      opacity: 1
    },
    coordinateSystem: "geo3D",
    minHeight: 15,
    bevelSize: 1,
    bevelSmoothness: 0,
    barSize: 1,
    animationDurationUpdate: 1000,
    label: {
      show: true,
      color: "#fff",
      distance: 0,
      fontFamily: "sans-serif",
      fontSize: 16,
      fontWeight: 700
    }
  },
  scatter: {
    color: "rgba(27, 255, 254, 1)",
    animationDurationUpdate: 1000,
    map: null,
    label: {
      show: false,
      labelFontColor: "rgba(255, 255, 255, 0.7)",
      labelFontFamily: "sans-serif",
      labelFontSize: 8,
      labelFontWeight: 400,
      offset: [0, 20],
      position: "right"
    },
    symbol: "circle", //'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
    symbolSize: [20, 20], //标记大小，包含中心点和波纹
    itemStyle: {
      color: "#ffcc00",
      borderWidth: 1,
      borderColor: "#fff"
    },
    data: null,
    dataFormatter: [],
    selectName: ''
  },
  geo3D: {
    show: true,
    type: "map3D",
    map: "全国",
    roam: true,
    left: "0%",
    regionHeight: 2,
    zlevel: -10,
    label: {
      show: true,
      distance: 0,
      color: "red", // 地图初始化区域字体颜色
      fontSize: 20
    },
    itemStyle: {
      // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
      color: "#0a599f", // 地图板块的颜色
      opacity: 1, // 图形的不透明度 [ default: 1 ]
      borderWidth: 2, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域   [ default: 0 ]
      borderColor: "#377CC5", // 图形描边的颜色。[ default: #333 ]
      areaColor: "#2D5F9F"
    },
    emphasis: {
      label: {
        show: true,
        color: "#fff000"
      }
    },
    regions: [],
    viewControl: {
      autoRotate: false,
      distance: 80,
      alpha: 50,
      beta: 0,
      zoomSensitivity: 0,
      panSensitivity: 0,
      rotateSensitivity: 0
    },
    light: {
      //光照阴影
      main: {
        color: "#fff", //光照颜色
        intensity: 1.2, //光照强度
        //shadowQuality: 'high', //阴影亮度
        shadow: true, //是否显示阴影
        alpha: 55,
        beta: 10
      },
      ambient: {
        intensity: 0.3
      }
    }
  },
  regionName: ''
}
